export const getRandomHexString = (length) => {
    var letters = '0123456789ABCDEF';
    var hex = '';
    for (var i = 0; i < length; i++) {
        hex += letters[Math.floor(Math.random() * 16)];
    }
    return hex;
}